module.exports = __webpack_public_path__ + "static/media/29830036-sUF0wSgs.5737384a.JPG";